/* @flow */
import CurrentUser from 'auth/CurrentUser';
import React from 'react';
import PromptStore from 'stores/PromptStore';
import RequireUser from 'components/mixins/RequireUser';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import JoinGroupModal from 'groups/components/JoinGroupModal.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Link from 'components/Link.jsx';
import LeadActions from 'actions/LeadActions';
import SetupActions from 'actions/SetupActions';

const SetupSubscription = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    RequireUser,
  ],

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION);
    }
  },

  onJoinGroup() {
    SetupActions.joinGroupDuringSetup();
    LeadActions.loadLeads(true);

    this.context.router.push('/information_required');
  },

  onSkip() {
    this.context.router.push('/information_required');
  },

  renderCreateClass() {
    if (CurrentUser.getUser().canCreateGroups()) {
      return (
        <BoxFooter>
          {'Or '}
          <Link
            className="SetupSubscription-CreateClass"
            onClick={() => this.context.router.push('/setup/class')}
            eventElementName="SetupSubscription-CreateClass">
            create a class
          </Link>
        </BoxFooter>
      );
    } else {
      return null;
    }
  },

  render() {
    return (
      <JoinGroupModal
        modal={false}
        footer={this.renderCreateClass()}
        onRequestHide={this.onSkip}
        onJoin={this.onJoinGroup}
      />
    );
  },
});

export default SetupSubscription;



// WEBPACK FOOTER //
// ./src/setup/components/SetupSubscription.jsx